module.exports = __webpack_public_path__ + "img/17853_S.29d740f1.png";